export const styles = theme => ({
  logo: {
    width: 200,
    display: 'block',
    margin: theme.spacing.unit * 2
  }
})



// WEBPACK FOOTER //
// ./src/components/Nav/styles.js